var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useState, useEffect } from 'react';
import { getNodes } from 'utils/paginationHelper';
import { useSpecialtiesLazyQuery, useSpecialtiesQuery } from 'apollo/queries/SPECIALTIES_SEARCH';
import { useSpecialtiesByUuidsLazyQuery } from 'apollo/queries/SPECIALTIES_BY_UUIDS_SEARCH';
import { isNil, isEmpty } from 'ramda';
export var DEFAULT_TITLE = 'Specialty';
var dataPath = ['specialties'];
var normalizeProviderValue = function (v) {
    if (isNil(v) || isEmpty(v))
        return [''];
    if (Array.isArray(v))
        return v.sort();
    return [v];
};
var useProviderSpecialties = function (search, value) {
    var _a, _b, _c;
    var _d = useState([]), uuidData = _d[0], setUuidData = _d[1];
    var _e = useSpecialtiesQuery(), data = _e.data, loading = _e.loading;
    // apollo is a damn garbage, compensating for bugged skip param
    var parsedValue = ((value === null || value === void 0 ? void 0 : value.length) > 0 && JSON.parse(value)) || [];
    var valueCrutch = normalizeProviderValue(parsedValue);
    var _f = useSpecialtiesLazyQuery(), searchByName = _f[0], _g = _f[1], searchData = _g.data, searchLoading = _g.loading;
    useEffect(function () {
        if (search) {
            searchByName({
                variables: {
                    search: search
                }
            });
        }
    }, [search, searchByName]);
    var _h = useSpecialtiesByUuidsLazyQuery({
        variables: {
            uuids: valueCrutch
        },
        onCompleted: function (res) {
            var uuidLoaded = getNodes(['specialties_by_uuids'])(res);
            if (uuidLoaded && (uuidLoaded === null || uuidLoaded === void 0 ? void 0 : uuidLoaded.length)) {
                setUuidData(uuidLoaded);
            }
        }
    }), searchByUuid = _h[0], uuidLoading = _h[1].loading;
    var values = getNodes(dataPath)(search ? searchData : data);
    var items = Object.values(__spreadArray(__spreadArray([], uuidData, true), values, true).reduce(function (acc, curr) {
        var _a;
        var _b;
        var itemValue = acc[curr.provider_name]
            ? JSON.stringify(Array.from(new Set(__spreadArray(__spreadArray([], JSON.parse(acc[curr.provider_name].value), true), [curr.uuid], false))))
            : JSON.stringify([curr.uuid]);
        return __assign(__assign({}, acc), (_a = {}, _a[curr.provider_name] = {
            label: curr.provider_name,
            value: itemValue,
            defaultChecked: (_b = JSON.parse(itemValue)) === null || _b === void 0 ? void 0 : _b.find(function (item) {
                return parsedValue === null || parsedValue === void 0 ? void 0 : parsedValue.includes(item);
            })
        }, _a));
    }, {})).sort(function (a, b) { return a.label.localeCompare(b.label); });
    var checkedItems = items.filter(function (item) { return item.defaultChecked; });
    var checkedValues = checkedItems.map(function (item) { return item.value; });
    var defaultTitle = "".concat(DEFAULT_TITLE).concat(((_a = checkedItems === null || checkedItems === void 0 ? void 0 : checkedItems[0]) === null || _a === void 0 ? void 0 : _a.label) ? ": ".concat((_b = checkedItems === null || checkedItems === void 0 ? void 0 : checkedItems[0]) === null || _b === void 0 ? void 0 : _b.label) : '').concat((checkedValues === null || checkedValues === void 0 ? void 0 : checkedValues.length) > 1 ? " + ".concat(checkedValues.length - 1) : '');
    var uuidName = (_c = uuidData === null || uuidData === void 0 ? void 0 : uuidData[0]) === null || _c === void 0 ? void 0 : _c.provider_name;
    return {
        loading: searchLoading || uuidLoading || loading,
        uuidName: uuidName,
        items: items,
        defaultTitle: defaultTitle,
        checkedValues: checkedValues,
        searchByUuid: searchByUuid
    };
};
export default useProviderSpecialties;
